import { ThemeConfig } from "antd";

const theme: ThemeConfig = {
	token: {
		fontFamily: "GothamPro",
	},
};

export default theme;
